import { render, staticRenderFns } from "./FANDV.vue?vue&type=template&id=6f716041&scoped=true&"
import script from "./FANDV.vue?vue&type=script&lang=js&"
export * from "./FANDV.vue?vue&type=script&lang=js&"
import style0 from "./FANDV.vue?vue&type=style&index=0&id=6f716041&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f716041",
  null
  
)

export default component.exports